import * as yup from 'yup';
import localization from '../../localization/registration.js';

export function isEmail(value) {
  return /@/.test(value);
}

export function validate(
  { isEnabledSMSAgreement = false, isEnabledPhoneNumber = false, isEnabledCheckedAgreeWithPrivacy = false },
  { contact, agreeWithSMSAgreement, agreeWithPrivacy }
) {
  let schema = yup.object().shape();

  if (isEnabledPhoneNumber) {
    const contactSchema = yup
      .string()
      .test('email-or-us-phone', function (value) {
        if (isPhoneNumber(value)) {
          if (!isUSACountryCode(value)) {
            return this.createError({ message: localization.shouldUseOnlyUSAPhoneNumber });
          }
          if (!isUSAPhoneNumberByLength(value)) {
            return this.createError({
              message: localization.USAPhoneNumberLength(value.slice(2).length),
            });
          }
        } else if (!yup.string().email().isValidSync(value)) {
          return this.createError({ message: localization.invalidEmail });
        }
        return true;
      })
      .required('Email or Phone number is required.');

    schema = schema.shape({
      contact: contactSchema,
    });
  } else {
    schema = schema.shape({
      contact: yup.string().email(localization.invalidEmail).required('Email is required.'),
    });
  }

  if (isEnabledSMSAgreement) {
    schema = schema.shape({
      agreeWithSMSAgreement: yup.boolean().oneOf([true], localization.shouldAgreeWithSMSAgreement),
    });
  }

  if (isEnabledCheckedAgreeWithPrivacy) {
    schema = schema.shape({
      agreeWithPrivacy: yup.boolean().oneOf([true], localization.shouldAgreeWithPrivacy),
    });
  }

  try {
    schema.validateSync({ contact, agreeWithSMSAgreement, agreeWithPrivacy }, { abortEarly: true });
    return makeValidationResult({ isValid: true });
  } catch (err) {
    return makeValidationResult({ message: err.errors[0] });
  }
}

function isPhoneNumber(number) {
  return /^\d+$/.test(number) || /^\+\d+$/.test(number);
}

function isUSACountryCode(phoneNumber) {
  return /^\+1/.test(phoneNumber);
}

function isUSAPhoneNumberByLength(phoneNumber) {
  return /^\d{10}$/.test(phoneNumber.slice(2));
}

function makeValidationResult({ isValid = false, message = '' }) {
  return {
    isValid,
    message,
  };
}
